module.exports = __webpack_public_path__ + "static/media/insta_icon.fc13420a.svg";